export default "__VITE_ASSET__C$M1PjmG__"